/**
 * The tooltips' settings: the phone breakpoint at which a tooltip becomes a
 * sheet (TooltipContext), and the Radix class strings for the sheet's sides
 * (components/ui/sheet reads those).
 *
 * Config already, so its numbers stay here rather than in tunables/ui. The
 * delays, sheet sizes, z-indexes, a11y switches and tooltip classes that once
 * sat here were read by nothing and are gone. @kept K5
 *
 * @module tooltipConfig
 */

/**
 * The tooltip settings. MOBILE_BREAKPOINT is in CSS pixels. @kept K5
 */
export const TOOLTIP_CONFIG = {
  // Breakpoints
  MOBILE_BREAKPOINT: 576, // in pixels - standard "sm" breakpoint

  // Theme-aware variants (using shadcn class variants)
  variants: {
    sheet: {
      default: 'fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300',
      top: 'inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top',
      bottom: 'inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom',
      left: 'inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm',
      right: 'inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm',
    },
  },
} as const;
